//@ts-nocheck
import React, { Fragment, useEffect, useState } from 'react'
import { Transforms, Editor, Range, Path } from 'slate'
import { ReactEditor, useSlateStatic } from 'slate-react'
import {
  cbModal,
  ModalBody,
  ModalHeader,
  InfiniteScrollTable,
  Button,
  ButtonGroup,
  ModalFooter,
  Select
} from '../../../../../../../../index'
import './style.css'
import { fetchEntries, fetchContentTypes, checkProps, isEmbedLink, fetchEnvironment, fetchLocale, setEntryInEditor, getReferenceNode } from '../../utils'
//@ts-ignore
import styles from './style.module.css'
import { InvalidPropsMsg } from '../../utils/InvalidPropsMessage/InvalidPropsMsg'
import { v4 } from 'uuid'
import { EmbedLinkBody, ReferenceBody, PublishStatusComponent } from './components'
import { getEmbedLinkDetails, updateLink } from './utils';
import { getUsers } from '../../image/request';
import { formatTime } from '../../image/Modal/util';
import ImageModal from '../../image/Modal/ModalComponent';
import AsyncLoader from '../../../../../../../AsyncLoader/AsyncLoader'
import { cx } from '@emotion/css'
import { getLowestElementAtSelection } from '../../../../../../../RichTextEditor/SuperChargedRte/elements/Element/utils'
import { cloneDeep } from 'lodash'

// to be move in utils
const ModalComponent = (props) => {
  const { editor, type } = props
  const [state, setState] = useState({
    entries: [],
    singleSelectedRowId: { data: {}, key: '' },
    totalEntries: 0,
    displayType: 'block',
    selectedContentType: null,
    loading: false,
    loadingCt: false,
    contentTypeUid: '',
    contentTypes: [],
    contentTypeOptions: [],
    apiQuery: '',
    locales: [],
    checkedUids: [],
    checkedUidDataSource: [],
    itemStatusMap: {},
    newTab: false,
    linkDetails: getEmbedLinkDetails(editor),
    users: {},
    environments: {}
  });
  const entriesPerPage = 12;
  const { customizedPagination } = editor.requestProps || {};
  const { entries, totalEntries, contentTypes, displayType, apiQuery, contentTypeUid, singleSelectedRowId, itemStatusMap, loading, selectedContentType, contentTypeOptions, loadingCt } = state;

  const getEntries = async (contentTypeUid, skipEntries = 0, limit = entriesPerPage) => {
    let res = await fetchEntries({
      contentTypeUid,
      limitPerPage: limit,
      skipEntries,
      query: apiQuery,
      ...props,
    })
    if (props.prefilled && (singleSelectedRowId.key === '')) {
      const entries = res['entries'];
      const entryUid = props?.attributes?.['entry-uid'],
        displayType = props?.attributes?.['display-type'],
        contentTypeUid = props?.attributes?.['content-type-uid'];
      entries.forEach(entry => {
        if (entry['uid'] === entryUid) {
          setState(state => ({
            ...state, displayType, singleSelectedRowId: {
              data: { ...entry, contentTypeUid }, key: entryUid
            }
          }));
        }
      })
    }
    setState(state => ({
      ...state,
      entries: [...state.entries, ...res['entries']],
      totalEntries: res['count']
    }));
  }

  const tableHead = [
    {
      Header: 'Name',
      accessor: 'title',
      id: 'title',
      default: true,
      disableSortBy: true,
    },
    {
      Header: 'Last Modified',
      accessor: (data) => <div className={'last-updated-by'}><span>{state.users[data.updated_by] || 'Anonymous'}</span> <span className='last-updated-by-time'>{formatTime(data.updated_at)}</span></div>,
      id: 'uid',
      default: true,
      disableSortBy: true,
    },
    {
      Header: 'Publish Status',
      accessor: (data) => {
        return <PublishStatusComponent users={state.users} locales={state.locales} data={data} environments={state.environments} />
      },
      id: 'publish_details',
      default: true,
      disableSortBy: true,
    }
  ]

  const getContentType = async () => {
    setState(state => ({ ...state, loadingCt: true }));
    let res = await fetchContentTypes(props)
    let reference_to = editor.requestProps['reference_to'] || []
    let ct = res['content_types'].filter(ct => reference_to.includes(ct.uid));
    let contentTypeOptions = ct.map((contentType) => {
      if (type === 'link') {
        let isPage = contentType['options']?.['is_page'];
        if (!isPage) {
          return {
            label: contentType['title'],
            value: contentType['uid'],
            id: contentType['uid'],
            isDisabled: true
          }
        }
      }
      return {
        label: contentType['title'],
        value: contentType['uid'],
        id: contentType['uid']
      }
    })

    contentTypeOptions = contentTypeOptions.filter(Boolean)
    setState(prevState => ({ ...prevState, contentTypes: ct, loadingCt: false, contentTypeOptions }));
  }

  useEffect(() => {
    (async () => {
      await getContentType();
      const promises = [
        getUsers(editor?.requestProps),
        fetchEnvironment(editor?.requestProps),
        fetchLocale(editor?.requestProps)
      ]
      Promise.all(promises).then(res => {
        setState(state => ({
          ...state,
          users: res[0],
          environments: res[1],
          locales: res[2]
        }))
      }).catch(err => {
        console.log(err, 'ERROR');
      });
    })();
  }, [])

  useEffect(() => {
    loadMoreItems({ skip: 0, limit: entriesPerPage, startIndex: 0, stopIndex: entriesPerPage });
  }, [contentTypeUid])

  useEffect(() => {
    if (props.prefilled && contentTypes.length) {
      const contentTypeUid = props?.attributes?.['content-type-uid'];
      let selectedCt = undefined;
      contentTypes.forEach(ct => {
        if (ct['uid'] === contentTypeUid) selectedCt = ct;
      });
      if (selectedCt)
        handleMenuClick({ id: contentTypeUid, value: contentTypeUid, label: selectedCt['title'] });
    }
  }, [contentTypes])

  useEffect(() => {
    if (contentTypeUid === '') return;
    loadMoreItems({ skip: 0, limit: entriesPerPage, startIndex: 0, stopIndex: entriesPerPage });
  }, [apiQuery])


  function handleMenuClick(ct) {
    setState(prevState => ({ ...prevState, apiQuery: '', entries: [], totalEntries: entriesPerPage, itemStatusMap: {}, contentTypeUid: ct['id'], selectedContentType: ct }));
  }

  function handleFetchTableData(query) {
    setState(prevState => ({ ...prevState, apiQuery: query['searchText'], entries: [], itemStatusMap: {} }));
  }

  const loadMoreItems = ({ skip, limit, startIndex, stopIndex }) => {
    if (!contentTypeUid) return;
    setState(prevState => {
      let itemStatusMapCopy = { ...prevState.itemStatusMap }
      for (let index = startIndex; index <= stopIndex; index++) {
        itemStatusMapCopy[index] = 'loading'
      }
      return ({ ...prevState, itemStatusMap: itemStatusMapCopy, loading: true })
    })
    getEntries(contentTypeUid, skip, limit).finally(() => {
      setState(prevState => {
        let updateditemStatusMapCopy = { ...prevState.itemStatusMap }

        for (let index = startIndex; index <= stopIndex; ++index) {
          updateditemStatusMapCopy[index] = 'loaded'
        }
        return ({ ...prevState, itemStatusMap: updateditemStatusMapCopy, loading: false })
      })
    })

  }

  const handleRowClick = (props) => {
    setState(prevState => ({ ...prevState, singleSelectedRowId: { data: { ...props, contentTypeUid: contentTypeUid }, key: props.key } }));
  }

  const handleDisplayType = (type) => {
    setState(prevState => ({ ...prevState, displayType: type }));
  }

  const handleEmbedSelect = () => {
    const entry = singleSelectedRowId.data;
    const { linkDetails, contentTypeUid, displayType, } = state
    const { prefilled, attributes, type, editor } = props
    insertEmbedEntry({ prefilled, attributes, editor, contentTypeUid, displayType, entry, type, linkDetails })
    // user analytics

    return props.closeModal();
  }

  const handleClose = () => {
    if (props.prefilled && editor.requestProps.userAnalytics) {
      const userAnalytics = editor.requestProps.userAnalytics;
      const metadata = {
        content_type_uid: contentTypeUid,
        stack_api_key: editor.requestProps['apiKey'],
        json_rte_field_uid: editor.requestProps['field_uid'],
        json_rte_field_type: editor.requestProps['field_type'],
        embedded_entry_type: displayType,
        embedded_entry_uid: singleSelectedRowId.data['uid'],
        mixpanel: true
      };
      if (type !== 'link') {
        userAnalytics.trackEvent("Cancel ‘Replace Embedded Entry within RTE with New Entry’", metadata);
      } else {
        metadata['embedded_entry_type'] = 'link';
        metadata['embedded_entry_url'] = singleSelectedRowId.data['url'];
        userAnalytics.trackEvent("Cancel ‘Replace Embedded Entry Link within RTE with New Entry Link’", metadata);
      }
    }

    return props.closeModal();
  }

  const isPropsValid = checkProps(props)
  let heightStyles = {};
  let tableHeight = type === "link" ? 250 : 400
  if (singleSelectedRowId.key !== "" && type !== "link") {
    heightStyles = {
      overflow: "hidden",
      maxHeight: `394px`
    }
  }
  let customClass = type === "link" ? "scrte-reference-modal-link" : ""
  let modalBodyCustomClassForLink = type === "link"
  return (
    <div className='cs-auto-draft-modal'>
      <ModalHeader title={props.title} closeModal={props.closeModal} />

      <ModalBody className={cx("modalBodyCustomClass", customizedPagination && 'no-count', modalBodyCustomClassForLink && "modalBodyCustomClassForLink")}>
        {!isPropsValid ? (
          <InvalidPropsMsg asset="Reference" />
        ) : (
          <Fragment>
            <div className={styles['dropdown']}>
              <Select
                version='v2'
                value={selectedContentType}
                onChange={handleMenuClick}
                options={contentTypeOptions}
                placeholder={loadingCt ? <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>Loading <AsyncLoader color="#647696" /></span> : 'Select Content Type'}
                canEditOption={false}
                width="200px"
              />

            </div>
            <div className={`scrte-infinite-list scrte-reference-modal ${customClass}`} style={{ ...heightStyles }} data-testid={"reference-modal"}>
              <InfiniteScrollTable
                itemSize={60}
                tableHeight={tableHeight || 400}
                canSearch={true}
                searchPlaceholder={'Search Entry'}
                serachValue={apiQuery}
                singleSelectedRowId={singleSelectedRowId.key}
                onRowClick={handleRowClick}
                data={entries}
                columns={tableHead}
                uniqueKey={'key'}
                fetchTableData={handleFetchTableData}
                loading={loading}
                totalCounts={totalEntries}
                loadMoreItems={loadMoreItems}
                itemStatusMap={itemStatusMap}
                minBatchSizeToFetch={entriesPerPage}
                name={{ singular: 'entry', plural: 'entries' }}
                columnSelector={false}
                emptyDescription={contentTypeUid === '' ? <p>Select a content type to choose entries from</p> : <p>No Entries available for this content type.</p>}
              />
            </div>
            {
              type === 'link' ? <div className='embed-entry-as-link-wrapper'> <EmbedLinkBody singleSelectedRowId={singleSelectedRowId} state={state} setState={setState} /></div> :
                singleSelectedRowId.key !== '' && <div className='embed-entry-select-modal-wrapper'><ReferenceBody singleSelectedRowId={singleSelectedRowId} displayType={displayType} handleDisplayType={handleDisplayType} /></div>
            }
          </Fragment>
        )}
      </ModalBody>

      <ModalFooter>
        <ButtonGroup>
          <Button version='v2' buttonType='tertiary' onClick={handleClose} testId={'embed-cancel'}>
            Cancel
          </Button>
          <Button version='v2' onClick={handleEmbedSelect} disabled={singleSelectedRowId.key === ''} testId={'embed-submit'}>
            Embed Selected Entry
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </div>
  )
}

export const handleClick = (e, editor, props = { title: "Choose Entry", prefilled: false, type, attributes: {} }) => {

  if (editor.isDraft) {
    if (props.isCreateNewEntryFlow) {
      return editor?.showCreateNewEntryModal({ ...props })
    }
  }
  
  const type = props?.['type'];
  
  if (type === "assetLink" && editor.customEmbedAssetsModal) {
    const CustomModal = editor.customEmbedAssetsModal;
    if (typeof CustomModal === 'function' || typeof CustomModal === 'object') {
      if (e) e.preventDefault();
      editor.setFullScreen();
      return cbModal({
        component: (modalProps) => <CustomModal editor={editor} type={type} {...props} {...modalProps} />,
        modalProps: {
          size: 'max',
          shouldReturnFocusAfterClose: false,
          customClass: 'reference__modal scrte-reference__modal'
        }
      })
    }
  }
  
  if (editor.useV2EmbedPicker) {
    if (editor.showAssetEmbedModal && props.type === 'assetLink') {
      return editor.showAssetEmbedModal({ ...props })
    }
    if (editor.showEntryEmbedModal) {
      return editor.showEntryEmbedModal({ ...props })
    }
  }

  if (e) e.preventDefault();
  editor.setFullScreen();
  cbModal({
    component: (modalProps) => type === 'assetLink' ? <ImageModal editor={editor} type={type} {...props} {...modalProps} /> : <ModalComponent {...props} {...modalProps} editor={editor} />,
    modalProps: {
      size: 'max',
      shouldReturnFocusAfterClose: false,
      customClass: 'reference__modal scrte-reference__modal'
    }
  })
}

export const ShortcutOpenReferenceOverlay = (event, editor, format, registryObj, props = { title: "Choose Entry", prefilled: false, attributes: {} }) => {
  event.preventDefault()

  if (!(editor.selection || editor.savedSelection)) {
    return
  }

  handleClick(event, editor, props)
}

const ReferenceButton = (props) => {
  const editor = useSlateStatic();
  return <React.Fragment>{props.children({ handleClick: (e) => handleClick(e, editor, props) })}</React.Fragment>
}

const replaceEmbedMetadata = (editor, element, entry, contentTypeUid) => {
  const path = ReactEditor.findPath(editor, element);
  const updatedAttrs = cloneDeep(element.attrs);
  updatedAttrs['entry-uid'] = entry.uid;
  updatedAttrs['content-type-uid'] = contentTypeUid;
  updatedAttrs['locale'] = entry.locale;

  Transforms.setNodes(editor, {
    attrs: updatedAttrs
  }, {
    at: path
  })
}

export const insertEmbedEntry = ({ prefilled, attributes, editor, contentTypeUid, displayType, entry, type, linkDetails, uid = undefined }) => {
  if (prefilled && editor.requestProps.userAnalytics) {
    const userAnalytics = editor.requestProps.userAnalytics;
    const metadata = {
      content_type_uid: contentTypeUid,
      stack_api_key: editor.requestProps['apiKey'],
      json_rte_field_uid: editor.requestProps['field_uid'],
      json_rte_field_type: editor.requestProps['field_type'],
      embedded_entry_type: displayType,
      embedded_entry_uid: entry['uid'],
      mixpanel: true
    };
    if (type !== 'link') {
      userAnalytics.trackEvent('Replace Embedded Entry within JSON RTE with New Entry', metadata);
    } else {
      metadata['embedded_entry_type'] = 'link';
      metadata['embedded_entry_url'] = entry['url'];
      userAnalytics.trackEvent('Replace Embedded Entry Link within RTE with New Entry Link', metadata);
    }
  }
  // replace logic
  if (prefilled && type !== 'link') {
    const { element } = attributes;
    const beforeDisplayType = attributes['display-type'];

    if(displayType === beforeDisplayType) {
      replaceEmbedMetadata(editor, element, entry, contentTypeUid)
      Transforms.collapse(editor, { edge: 'end' })
      setEntryInEditor(editor, entry);
      return
    }

    const path = ReactEditor.findPath(editor, element);
    if (displayType === 'inline' && beforeDisplayType === 'block') {
      Editor.withoutNormalizing(editor, () => {
        Transforms.removeNodes(editor, { at: path })
        Transforms.insertNodes(editor, { type: 'p', uid: v4().split('-').join(''), attrs: {}, children: [{ text: '' }] }, {at: path})
        Transforms.select(editor, path)
      })
    }

    if(displayType === 'block' && beforeDisplayType === 'inline') {
      Transforms.removeNodes(editor, { at: path })
    }

  }
  if (type === 'link' && isEmbedLink(editor)) {
    // update embed link;
    setEntryInEditor(editor, entry);
    updateLink(editor, linkDetails, entry, contentTypeUid);
    return
  }

  let selection = editor.selection || editor.savedSelection;
  if (!selection) {
    ReactEditor.focus(editor);
    Transforms.select(editor, Editor.end(editor, []));
  }
  else if (entry['uid'] === '') {
    return
  }

  selection = editor.selection || editor.savedSelection;

  const node = getReferenceNode({ type, displayType, entry, linkDetails, uid })

  if (type === 'link') {
    Transforms.select(editor, selection);
    if (selection && Range.isCollapsed(selection)) {
      Transforms.insertNodes(editor, node, { at: selection });
    } else {
      Transforms.wrapNodes(editor, node, { split: true });
      Transforms.insertText(editor, linkDetails.text || '/undefined', { at: editor.selection });
    }
  }
  else {
    if (!Range.isCollapsed(selection)) {
      Transforms.select(editor, selection);
      Transforms.delete(editor, { at: selection });
      Transforms.insertNodes(editor, node);
    }
    else {  
      const parent = getLowestElementAtSelection(editor, selection)
      const [listParent] = Editor.nodes(editor, { at: editor.selection, match: n => n.type === 'ul' || n.type === 'ol', mode: "highest" });
      if (displayType !== "inline" && listParent) {
        Transforms.insertNodes(editor, node, { at: Path.next(listParent[1]) });
      }
      else if (displayType !== "inline" && parent && parent[0].type !== "doc" && !(['td', 'th'].includes(parent[0].type)) && Editor.isEmpty(editor, parent[0])) {
        Editor.withoutNormalizing(editor, () => {
          Transforms.removeNodes(editor, { at: parent[1] })
          Transforms.insertNodes(editor, node, { at: parent[1] });
        })
      }
      else {
        Transforms.insertNodes(editor, node, { at: selection });
      }
    }
  }
  Transforms.collapse(editor, { edge: 'end' })
  setEntryInEditor(editor, entry);
}
export default ReferenceButton;
